const gradients = {
  TRANSPARENT_TO_WHITE: 'linear-gradient(90deg, #FFFFFF00, #FFFFFF)',
};

export default gradients;
